import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'noSafeHtml',
})
export class NoSafeHtmlPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  public transform(value: any) {
    return this.domSanitizer.bypassSecurityTrustHtml(value);
  }
}
